var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#4392CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48263 14.3438H8.51737C7.79288 14.3438 7.58756 13.6722 7.58756 13.1592C7.58756 12.6462 7.62413 12.4139 7.62413 12.1821C7.62413 11.8165 7.43962 10.9036 7.10494 10.5211C6.453 9.77576 6.04237 9.10807 6.04237 8.13945C5.47537 7.84639 4.473 7.57751 4.08712 7.1382C3.70125 6.69889 3.375 6.07507 3.375 5.18295C3.375 4.95514 3.42337 4.63339 3.52012 4.21826C3.74231 4.91239 4.08431 5.38826 4.54612 5.64701C5.22169 6.02614 5.98331 6.30682 6.63412 6.30682H11.3659C12.0167 6.30682 12.7778 6.02557 13.4539 5.64701C13.9151 5.38826 14.2577 4.91239 14.4799 4.21826C14.5766 4.63339 14.625 4.95514 14.625 5.18295C14.625 6.07451 14.2987 6.69776 13.9129 7.13707C13.527 7.57639 12.5246 7.84582 11.9576 8.13832C11.9576 9.10751 11.547 9.7752 10.8951 10.5205C10.5604 10.903 10.3759 11.8159 10.3759 12.1816C10.3759 12.4133 10.4124 12.6456 10.4124 13.1586C10.4124 13.6716 10.2071 14.3438 9.48263 14.3438Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOx);
export default __webpack_public_path__ + "static/media/ox.231954f80fccfe4e80452a9964713248.svg";
export { ForwardRef as ReactComponent };